import ScrollReveal from "scrollreveal";

const mediaReveal = ScrollReveal({
  distance: "150%",
  origin: "top",
  opacity: 0,
  duration: 1500,
  delay: 500,
  easing: "cubic-bezier(0,.45,0,1)",
});
const multipleMediaReveal = ScrollReveal({
  origin: "top",
  opacity: 0,
  delay: 500,
  duration: 2000,
  distance: "15%",
  easing: "ease-in-out",
});
if (window.matchMedia("(max-width: 767.98px)").matches) {
  mediaReveal.reveal(".media-content", {
    origin: "bottom",
  });
} else {
  mediaReveal.reveal(".media-content");
}
multipleMediaReveal.reveal(".multiple-media-small");
multipleMediaReveal.reveal(".multiple-media-large", {
  origin: "bottom",
});
